import { render } from "./TransactionDetail.vue?vue&type=template&id=55fcf58f&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"

import "./TransactionDetail.vue?vue&type=style&index=0&id=55fcf58f&lang=css"
import "./TransactionDetail.vue?vue&type=style&index=1&id=55fcf58f&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fcf58f"]])

export default __exports__